import { Control } from 'react-hook-form';

import { DataGridColSettings } from '@/components/DataGrid/utils';
import { IUnitType } from '@/models';

export interface SubType {
  label: string;
  min?: string | number;
  max?: string | number;
  isDefault?: boolean;
}

export interface Resource {
  type: string;
  min?: string | number;
  max?: string | number;
  subTypes?: SubType[];
  isDefault?: boolean;
}

export interface IUnitTypeForm {
  name: string;
  agencyType: string;
  resources: Resource[];
  isDispatchToHQEnabled: boolean;
  closeUnitShiftWithCFS: boolean;
  isDefault: boolean;
}

export const UnitTypeDefaultValues: IUnitTypeForm = {
  name: '',
  agencyType: '',
  resources: [],
  isDispatchToHQEnabled: false,
  closeUnitShiftWithCFS: false,
  isDefault: false,
};

export const equipmentTypeMap: Record<string, string> = {
  RADIO: 'Radio',
  GUN: 'Gun',
  GPS_TRACKER: 'GPS Tracker',
};

export const UnitTypeFormFields = {
  title: 'Unit Type Information',
  items: [
    {
      name: 'name',
      label: 'Unit Type Name',
      type: 'text',
      grid: {},
      rules: {
        required: {
          value: true,
          message: 'This field is required.',
        },
      },
    },
  ],
};

export const UnitTypeToggles = [
  {
    name: 'isDispatchToHQEnabled',
    label: 'Enable Dispatch HQ',
  },
  {
    name: 'closeUnitShiftWithCFS',
    label: 'Close Unit Shift With CFS',
  },
];

export const resourceTypes = ['Vehicle', 'Employee', 'Equipment'];
export const resourceTypeMap: Record<string, string> = {
  VEHICLE: 'Vehicle',
  PEOPLE: 'Employee',
  EQUIPMENT: 'Equipment',
};

export const subTypeOptions = ['Radio', 'Gun', 'GPS Tracker'];

export const equipmentSubTypeMap: Record<string, string> = {
  Radio: 'RADIO',
  Gun: 'GUN',
  'GPS Tracker': 'GPS_TRACKER',
};

export const maxNumberOptions = Array.from({ length: 10 }, (_, i) => i + 1);
export const minNumberOptions = Array.from({ length: 11 }, (_, i) => i);

export interface IUnitTypeFormProps {
  control: Control<IUnitTypeForm>;
  agencyType: string;
}

export const unitTypesDataGridCols: DataGridColSettings[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

export const agencyTypeItems = [
  { label: 'Fire', value: 'FIRE' },
  { label: 'Police', value: 'POLICE' },
  { label: 'Emergency Management', value: 'EMERGENCY_MANAGEMENT' },
  { label: 'EMS', value: 'EMS' },
  { label: 'Municipal Services', value: 'MUNICIPAL_SERVICES' },
];

export interface MenuState {
  anchorEl: null | HTMLElement;
  selectedUnitType: IUnitType | null;
}

export const agencyTypeLabels: Record<string, string> = {
  FIRE: 'Fire',
  POLICE: 'Police',
  EMERGENCY_MANAGEMENT: 'Emergency Management',
  EMS: 'EMS',
  MUNICIPAL_SERVICES: 'Municipal Services',
};
